import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from 'axios';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';
import setAuthorizationToken from './utils/setAuthorizationToken';
import { store, persistor } from './store';
import { getProfile } from 'store/profile';
import { getIsNewMessage } from 'store/message/newMessage';
import { initAnalytics } from './utils/analytics';
import { getCookie } from './utils/cookies';
import { refreshAuthTokens } from './utils/refreshAuthorizationToken';
import { forceLogout } from 'utils/forceLogout';

import './i18n';
import './index.css';

initAnalytics();

axios.defaults.baseURL = import.meta.env.VITE_API_URL;

function wasUserAuthenticated() {
    try {
      const authSettingsJson = localStorage.getItem('persist:root');
      const parsedAuthSettings = JSON.parse(authSettingsJson);
      const parsedAuth = JSON.parse(parsedAuthSettings.auth);

      return parsedAuth.authenticated;
    } catch {
      return false;
    }
}

async function initApp() {
  const accessToken = getCookie('access_token');
  const refreshToken = getCookie('refresh_token');

  if (!refreshToken) {
    if (wasUserAuthenticated()) {
      return forceLogout()
    }

    return;
  }

  try {
    if (!accessToken) {
      await refreshAuthTokens(refreshToken)
    }

    setAuthorizationToken();

    store.dispatch(getProfile());
    store.dispatch(getIsNewMessage());
  } catch (e) {
    forceLogout();
  }
}

initApp();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <BrowserRouter>
        <Suspense fallback={''}>
          <App />
        </Suspense>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);
